import React, {useCallback} from "react";
import {CellProps, Column} from "react-table";
import {Table} from "../../common/table/Table";
import {Salesman} from "../../../../types/admin/room";

interface DataType extends Salesman {
  operation?: string
}

interface SecondarySalesmanListProps {
  tableData: DataType[];
  removeSecondarySalesman: (index: number) => void;
}

export const SecondarySalesmanList = (props: SecondarySalesmanListProps) => {
  const { tableData, removeSecondarySalesman } = props;
  const OperationCell = useCallback(({ row }: CellProps<DataType>) => {

    return (
      <button
        className="btn-primary mb-1"
        type='button'
        onClick={() => {
          removeSecondarySalesman(row.index);
        }}
      >
        解除
      </button>
    );
  }, [removeSecondarySalesman]);

  const columns: Column<DataType>[]  = React.useMemo(
    () => [
      {
        Header: '副営業担当者名',
        accessor: 'userName',
      },
      {
        Header: '操作',
        accessor: 'operation',
        Cell: OperationCell,
      },
    ],
    [OperationCell]
  );

  return (
    <Table
      tableData={tableData}
      columns={columns}
    />
  );
}